import { qs } from "../utils/lib"
export default function Loader() {
    const loader = qs('.site_loader')
    if (loader && !loader.classList.contains('loaded')) {
        loader.classList.add('loaded')
    }
}